module.exports = __webpack_public_path__ + "spanish-flag.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/spanish-flag.svg
// module id = 854
// module chunks = 0